import './plans.css';

function Plans() {
  return (
    <div className="plans-container">
      <h1>Nossos Planos</h1>
      <p>Escolha o plano que melhor se adapta às suas necessidades.</p>
    </div>
  );
}

export default Plans;